/**
 *   Created by ATopcu in 2019
 */
import { fetchCostBasisOptions } from "@ls/grouping-service";
import { exchange } from "@ls/js-fetch";
import SummaryType from "state/selections/Constants/SummaryType";
import SelectionState from "state/selections/SelectionState";
import { selectGetBaseGroupingParams } from "state/selections/selector";
import { splitByCalcType } from "state/util";
import scope from "./scope";
import { selectDefinitions } from "./selectors";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_BOOK_BASIS_VALUES = `${scope}/REQUEST_BOOK_BASIS_VALUES`;
export const RECEIVE_BOOK_BASIS_VALUES = `${scope}/RECEIVE_BOOK_BASIS_VALUES`;
export const requestBookBasisValues = () => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_BOOK_BASIS_VALUES });
    dispatch({
      type: RECEIVE_BOOK_BASIS_VALUES,
      data: Object.values((await fetchCostBasisOptions()) || {}),
    });
  };
};

export const REQUEST_BOOK_ANALYTICS_DATA = `${scope}/REQUEST_BOOK_ANALYTICS_DATA`;
export const RECEIVE_BOOK_ANALYTICS_DATA = `${scope}/RECEIVE_BOOK_ANALYTICS_DATA`;

export const requestBookAnalyticsData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
    const getBaseGroupingParams = selectGetBaseGroupingParams(state);

    const [absDefinitions, relDefinitions, bmkDefinitions] =
      splitByCalcType(definitions);

    const request = async (summary, defs, benchesToo) => {
      dispatch({ type: REQUEST_BOOK_ANALYTICS_DATA, summary });
      const [params] = getBaseGroupingParams({
        summary,
        benchesToo,
        analytics: [...new Set(defs.map(({ bookAnalytic }) => bookAnalytic))],
        costBases: [...new Set(defs.map(({ basis }) => basis))],
      });
      const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

      dispatch({
        type: RECEIVE_BOOK_ANALYTICS_DATA,
        summary,
        data: (
          await exchange({
            url,
            params,
            cancelId: `data-${scope}-${summary}`,
          })
        )?.data,
      });
    };

    if (absDefinitions.length || bmkDefinitions.length) {
      request(
        SummaryType.ABSOLUTE,
        [...absDefinitions, ...bmkDefinitions],
        bmkDefinitions.length > 0
      ).then();
    }
    if (relDefinitions.length) {
      request(SummaryType.RELATIVE, relDefinitions, true).then();
    }
  };
};
